export default {
  Draft: { value: 'DFT', text: 'Draft' },
  Assigned: { value: 'ASS', text: 'Assigned' },
  Submitted: { value: 'SUB', text: 'Submitted' },
  Closed: { value: 'CLS', text: 'Closed' },
  Archived: { value: 'ARC', text: 'Archived' }
}
